import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { ObjectTypes } from '@fi-shared/types';
import { RoleService } from '@fi-app/role/services/role.service';
import { AreaService } from '@fi-app/area/area.service';
import { BusinessAreaService } from '@fi-app/business-area/business-area.service';
import { BehaviorSubject } from 'rxjs';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { FiContentLanguageSharedService } from '@fi-shared/fi-content-language-shared/fi-content-language-shared.service';

@Component({
    selector: 'fi-extend-sharing-container',
    template: `
        <div class="fi-container">
          @if (loading$ | async) {
            <div class="text-center">
              <fi-loading class="small"></fi-loading>
            </div>
          }
        
          @if (!(loading$ | async)) {
            <fi-page-header [editTabsSettings]="EditTabs" [isSaveButtonShown]="false"></fi-page-header>
            <div class="fi-content">
              <fi-extend-sharing-content
                [objectId]="objectId"
                [objectType]="objectType"
                [objectName]="objectName"
                >
              </fi-extend-sharing-content>
            </div>
          }
        </div>
        `,
    styleUrls: ['./extend-sharing-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-extend-sharing-container' },
    standalone: false,
})
export class ExtendSharingContainerComponent implements OnInit {
    @Input() objectId: number;
    @Input() objectType: ObjectTypes;

    loading$ = new BehaviorSubject<boolean>(true);
    objectName: string;
    EditTabs: EditTabsModel;

    constructor(
        private appTextService: AppTextService,
        private roleService: RoleService,
        private areaService: AreaService,
        private businessAreaService: BusinessAreaService,
        private fiContentLanguageSharedService: FiContentLanguageSharedService,
    ) {}

    ngOnInit(): void {
        this.getObjectData();
    }

    getObjectData() {
        this.getCurrentObjectDataPromise().then((result) => this.setObjectName(result));
    }

    private getCurrentObjectDataPromise() {
        switch (this.objectType) {
            case ObjectTypes.BusinessArea:
                return this.businessAreaService.GetBusinessArea(this.objectId);
            case ObjectTypes.Area:
                return this.areaService.GetArea(this.objectId);
            case ObjectTypes.Role:
                return this.roleService.getRole(this.objectId);
        }
    }

    private setObjectName(objectData) {
        const objectName = this.fiContentLanguageSharedService.getContentLanguageValueForDisplayContent(
            objectData.Names,
        );
        this.objectName = objectName;
        this.EditTabs = new EditTabsModel(this.getHeaderText(), this.appTextService.get('common.cancel'));
        this.loading$.next(false);
    }

    private getHeaderText(): string {
        return `${this.appTextService.get('sharing.extend_sharing_to')} ${this.objectName}`;
    }
}
